<template>
  <b-table
    show-empty
    head-variant="dark"
    empty-text="No Claims available."
    stacked="md"
    bordered
    striped
    small
    sticky-header="200px"
    :busy="isLoading"
    :items="claimsummary"
    :fields="fieldsClaim"
    style="font-size: 12px"
  >
    <template #table-busy>
      <div class="text-center text-primary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <!-- <template v-slot:thead-top="">
        <b-tr>
            <b-th colspan="2"><span class="sr-only">SL and District Name</span></b-th>
            <b-th variant="secondary" colspan="5">Pending Claims</b-th>
        </b-tr>
        </template> -->

    <template v-slot:cell(SL)="row">
      {{ row.index + 1 }}
    </template>

    <template v-slot:cell(Accounts)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Accounts')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Accounts }}</b-button
      >
    </template>

    <template v-slot:cell(Auditor)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Auditor')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Auditor }}</b-button
      >
    </template>

    <!-- new Dgm start  -->
    <template v-slot:cell(DGM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'DGM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.DGM }}</b-button
      >
    </template>
    <!-- new Dgm end -->

    <template v-slot:cell(GM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'GM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.GM }}</b-button
      >
    </template>

    <template v-slot:cell(MD)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'MD')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.MD }}</b-button
      >
    </template>

    <template v-slot:cell(ToBePaid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'ToBePaid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.ToBePaid }}</b-button
      >
    </template>

    <template v-slot:cell(Paid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Paid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Paid }}</b-button
      >
    </template>

    <template v-slot:cell(Rejected)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Rejected')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Rejected }}</b-button
      >
    </template>
    <template v-slot:cell(Applicant)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Applicant')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Applicant }}</b-button
      >
    </template>
  </b-table>
</template>
<script>
import apis from "@/apis";
import * as _ from "lodash";
export default {
  props: {
    userId: {
      type: String,
      default: null
    },
    roleId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.getClaimSummary('1');
    this.$root.$on('component1', (loanType) => {
            // your code goes here
            console.log(loanType.temploanType);
            this.getClaimSummary(loanType.temploanType);
        })
    // Call emitTtlEvent when the component is mounted or when appropriate
    this.emitTtlEvent();
  },
  methods: {
    getClaimSummary(loanType) {
      this.isLoading = true;
      let promise = (this.roleId === 3 && this.userId)
        ? apis.ReadClaimDashBoardRM(this.userId)
        : apis.ReadClaimDashBoard(loanType);

      promise
        .then((response) => {
          if (response.status == 401) {
            this.$store.dispatch("logout");
            this.$router.replace("/");
            return;
          }
          if (response.status == 200) {
            let allData = response.body;

            // For RM, filter to only the districts in their division
            const loggedUser = this.$store.getters.loggedUser;
            if (loggedUser && loggedUser.RoleID === 3) {
              const divisionDistricts = {
                1: ['Mumbai City','Mumbai Suburban','Thane','Palghar','Raigad','Ratnagiri','Sindhudurg'],
                2: ['Pune','Kolhapur','Sangli','Satara','Solapur'],
                3: ['Nashik','Ahilyanagar','Dhule','Jalgaon','Nandurbar'],
                4: ['Chhatrapati Sambhajinagar','Beed','Parbhani','Jalna'],
                5: ['Latur','Dharashiv','Nanded','Hingoli'],
                6: ['Amravati','Akola','Buldhana','Yavatmal','Washim'],
                7: ['Nagpur','Bhandara','Wardha','Chandrapur','Gadchiroli','Gondia']
              };
              const allowedNames = divisionDistricts[loggedUser.RegistrationType];
              if (allowedNames) {
                const filtered = allData.filter(d => allowedNames.includes(d.DistrictName));
                const cols = ['Accounts','Auditor','DGM','GM','MD','ToBePaid','Paid','Rejected','Applicant'];
                const total = { SL: filtered.length + 1, DistrictName: 'TOTAL', DistrictID: '00000000-0000-0000-0000-000000000000' };
                cols.forEach(col => { total[col] = filtered.reduce((sum, d) => sum + (d[col] || 0), 0); });
                allData = [...filtered, total];
              }
            }

            this.claimsummary = allData;
            if (this.RoleID == 4) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].Accounts;
            this.PendingLabel = "Pending MD Approval";
            }
            // new Dgm start
            else if (this.RoleID == 5) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].DGM;
            this.PendingLabel = "Pending PM Approval";
            }
            // new Dgm end

            else if (this.RoleID == 5) {
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.PendingCountLOI = ttl[0].GM;
            this.PendingLabel = "Pending GM Approval";
            }else if (this.RoleID == 3) {
              let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
              this.PendingCountLOI = ttl[0].MD;
              this.PendingLabel = "Pending MD Approval";
            }
            let ttl = _.filter(this.claimsummary, { DistrictName: "TOTAL" });
            this.$emit(
              "ttl",
              ttl[0].Accounts,
              ttl[0].DGM,
              ttl[0].GM,
              ttl[0].MD,
              ttl[0].Applicant,
              ttl[0].Paid
            );
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
        var promise1;
      if (this.RoleID !== 3 && this.RoleID != 4 && this.RoleID != 5) {
        //promise1 = apis.getApplicationSummary(this.selectedDistrict);
      } else if (this.RoleID == 3 || this.RoleID == 4 || this.RoleID == 5) {
        //promise1 = apis.getApplicationSummaryMD(this.loanType);
      } else {
        return;
      }
    },
    viewClaims(item, sts) {
      this.$store.dispatch("setDistrict", item.DistrictID);
      //this.$store.dispatch("setAppStatus", sts);
      this.$store.dispatch("setStatusOwner", sts);
      this.$store.dispatch("setLoanType", 1);
      this.$router.push("/approveclaims");
    },
    emitTtlEvent() {
      // Event is emitted from getClaimSummary after data loads; nothing to do here
    },
  },
  data() {
    return {
      claimsummary: [],
      isLoading: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      id:1,
      fieldsClaim: [
        { key: "SL", label: "SL" },
        { key: "DistrictName", label: "District Name" },
        { key: "Accounts", label: "DM" },
        { key: "Auditor", label: "RM" },

        // new Dgm start
        { key: "DGM", label: "PM" },
        // new Dgm end

        { key: "GM", label: "GM" },
        { key: "MD", label: "MD" },
        { key: "ToBePaid", label: "To Be Paid" },
        { key: "Paid", label: "Paid" },
        { key: "Rejected", label: "Rejected" },
        { key: "Applicant", label: "Applicant" },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/ClaimsTable.vue